module.exports = __webpack_public_path__ + "static/img/图层 528.69e0de41.png";